var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartyHearts1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 144,
    viewBox: "0 0 86 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hearts"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Highlight 10",
    d: "M12.9176 75.6543C30.5702 70.1648 44.9874 91.9088 44.9874 91.9088C44.9874 91.9088 68.9534 76.7383 81.8803 86.8065C94.8072 96.8748 41.6512 140.665 37.6914 137.026C21.7524 122.378 -2.93381 80.5836 12.9176 75.6543Z",
    stroke: "#E5B422",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Highlight 11",
    d: "M21.2799 39.7551C25.6723 30.8424 40.5229 41.5323 40.5229 41.5323C40.5229 41.5323 49.4006 23.6091 57.9501 31.6823C66.4995 39.7555 48.5033 66.5578 45.8043 65.5228C34.9406 61.3567 14.9993 52.4993 21.2799 39.7551Z",
    stroke: "#E5B422",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Highlight 12",
    d: "M17.1775 2.21693C22.832 0.981416 26.7417 8.1536 26.7417 8.1536C26.7417 8.1536 32.7751 2.34807 38.3873 7.55885C43.9996 12.7696 24.3837 23.2717 23.2468 22.0296C18.6708 17.03 8.49951 4.11305 17.1775 2.21693Z",
    stroke: "#E5B422",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyHearts1);
export default __webpack_public_path__ + "static/media/party-hearts1.bdf7ae26b8162f651f96b93a932759c3.svg";
export { ForwardRef as ReactComponent };